'use client'

import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

import ConversationMessage from './ConversationMessage'
import { isMessageGrouped } from '../../utils'
import usePhotosDialog from './usePhotosDialog'

type Props = {
  toggleSidebar?: () => void
  openOfferModal?: () => void
}

const ConversationMessages = ({ toggleSidebar, openOfferModal }: Props) => {
  const { conversation, conversationMessages } = useConversationContext()

  const { photosDialogElement, onThumbnailClick } = usePhotosDialog(conversationMessages)

  if (!conversationMessages.length) return null

  return (
    <>
      {conversationMessages.map((message, index) => (
        <ConversationMessage
          key={index}
          {...message}
          transactionId={conversation?.transactionId}
          isGrouped={isMessageGrouped(message, conversationMessages?.[index - 1])}
          isLast={index + 1 === conversationMessages.length}
          toggleSidebar={toggleSidebar}
          openOfferModal={openOfferModal}
          conversationId={conversation?.id}
          onThumbnailClick={onThumbnailClick}
        />
      ))}
      {photosDialogElement}
    </>
  )
}

export default ConversationMessages
